<template>
  <div class="wg-row">
    <div class="analysis-list">
      <div v-for="(doc, index) in docs" :key="'doc-'+index" class="list-item">
        <div :class="['item', doc.type]">
          <div v-if="doc.type == 'form'">Campionamento {{ doc.formCode }}</div>
          <div v-if="doc.type == 'coc'">Presa in carico COC {{ doc.analysisCode }}</div>
          <div v-if="doc.type == 'preview'">Anteprima analisi {{ doc.analysisCode }}</div>
          <div v-if="doc.type == 'report'">Report analisi {{ doc.analysisCode }}</div>
          <div v-if="doc.files.length > 0" class="files-list">
            <img v-for="(fileId, fIndex) in doc.files" :key="'file-' + fIndex" :src="$anm22.icons.getWorldIcon('fileDefault')" @click="openDocAttachment(doc, fileId)" />
          </div>
        </div>
      </div>
      <div v-if="docs.length <= 0">{{ $anm22.strLang(lang, 'No items', 'Nessun campione associato al progetto.') }}</div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
  },
  data() {
    return {
      docs: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline
    }),
    
  },
  methods: {
    openDocAttachment(doc, fileId) {
      if (doc.type == 'form') {
        window.open(fileId, '_blank');
      } else {
        window.open('https://www.anm22.it/app/tasks/spa/controller/coc/file?idCoc=' + doc.idCoc + '&file=' + fileId, '_blank');
      }
    },
  },
  async created() {
    const response = await this.$http.get(
      "coc/index?projectId=" + this.projectId
    );
    this.docs = response.data.docs;
  }
};
</script>
 
<style lang="scss" scoped>
  .analysis-list {
    .list-item {
      .item {
        padding: 3px 0 3px 10px;

        &.form {
          padding-left: 0;
        }

        &>div {
          display: inline-block;
          vertical-align: middle;

          &.files-list {
            img {
              opacity: 0.6;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>
 